import { MuiTelInput } from "mui-tel-input";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
	phoneInputDefaultCountryDictionary,
	phoneInputLangOfCountriesDictionary,
	phoneInputPreferredCountries,
} from "../../../constants";

const ControlledPhoneInput = ({
	control,
	defaultValue = "",
	name,
	label,
	error,
	errorMessage,
	startAdornment,
	endAdornment,
	...rest
}) => {
	const { i18n } = useTranslation();
	const [isFocused, setIsFocused] = useState(false);

	const handleFocus = () => {
		setIsFocused(true);
	};

	const handleBlur = () => {
		setIsFocused(false);
	};

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => {
				// const splittedValue = value && value.split(" ");
				return (
					<MuiTelInput
						className="phone-input"
						forceCallingCode
						defaultCountry={
							phoneInputDefaultCountryDictionary[i18n.language] || "PL"
						}
						langOfCountryName={
							phoneInputLangOfCountriesDictionary[i18n.language] || "PL"
						}
						preferredCountries={phoneInputPreferredCountries}
						continents={["EU"]}
						size="small"
						fullWidth
						label={label}
						value={value}
						onChange={onChange}
						onFocus={handleFocus}
						onBlur={handleBlur}
						error={error}
						helperText={errorMessage ? errorMessage : ""}
						slotProps={{
							inputLabel: {
								shrink: true,
							},
						}}
						{...rest}
					/>
				);
			}}
		></Controller>
	);
};

export default ControlledPhoneInput;
